import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PictureForm from '../PictureForm';

class Step3 extends PureComponent {
  static propTypes = {
    sections: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
    hexColorCodeC: PropTypes.string.isRequired,
    applicants: PropTypes.number.isRequired,
    tabIndex: PropTypes.number.isRequired,
    setTabIndex: PropTypes.func.isRequired,
  };

  renderContent = () => {
    const { sections, season } = this.props;
    const content = [];
    const hasSections = !!Object.keys(sections).length;
    for (let i = 0; i < this.props.applicants; i++) {
      content.push(
        <div
          key={i}
          className={classnames('ui bottom attached tab segment accented', {
            active: this.props.tabIndex === i,
          })}
        >
          {hasSections && (
            <PictureForm form={`member${i + 1}`} season={season} />
          )}
        </div>
      );
    }
    return content;
  };

  renderTabSections() {
    if (this.props.applicants) {
      const numOfApps = this.props.applicants;
      if (numOfApps >= 2) {
        const tabs = [];
        for (let i = 0; i < numOfApps; i++) {
          tabs.push(
            <div
              key={i}
              className={classnames('item', {
                active: this.props.tabIndex === i,
              })}
              onClick={() => this.props.setTabIndex(i)}
            >
              Member {i + 1}
            </div>
          );
        }

        return (
          <div
            style={{ borderColor: `#${this.props.hexColorCodeC}` }}
            className="ui top attached tabular menu accented"
          >
            {tabs}
            <div
              className={classnames('item', {
                active: this.props.tabIndex === numOfApps,
              })}
              onClick={() => this.props.setTabIndex(numOfApps)}
            >
              Team
            </div>
          </div>
        );
      }
    }

    return '';
  }

  render() {
    const { season, sections } = this.props;
    const hasSections = !!Object.keys(sections).length;
    return (
      <div>
        {this.renderTabSections()}
        {this.renderContent()}
        <div
          className={classnames('ui bottom attached tab segment accented', {
            active: this.props.tabIndex === this.props.applicants,
          })}
        >
          {hasSections && <PictureForm form="team" season={season} />}
        </div>
      </div>
    );
  }
}

export default Step3;



// WEBPACK FOOTER //
// ./src/components/apply/Step3.js